import React from "react";
import usePrice from "../../hooks/usePrice";
import useCalculator from "../../hooks/useCalculator";
import {useSelector} from "react-redux";
import {FEATURE_PRICE_TYPE_PRICE_PER_SOURCE} from "../../constants/FeaturePriceTypeConstant";

function Features({ values }) {
    const {priceFormat} = usePrice();
    const {calculateFeaturePrice} = useCalculator();
    const {features} = useSelector(state => state.orderOptions.data);


    const resultFeatures = [];

    if (values.plagiarismReport) {
        resultFeatures.push({
            key: 'plagiarismReport',
            label: features.plagiarismReport.label,
            price: calculateFeaturePrice(features.plagiarismReport, true)
        });
    }
    if (values.abstractPage) {
        resultFeatures.push({
            key: 'abstractPage',
            label: features.abstractPage.label,
            price: calculateFeaturePrice(features.abstractPage, true)
        });
    }
    if (values.editorCheck) {
        resultFeatures.push({
            key: 'editorCheck',
            label: features.editorCheck.label,
            price: calculateFeaturePrice(features.editorCheck, true)
        });
    }
    if (values.vipSupport) {
        resultFeatures.push({
            key: 'vipSupport',
            label: features.vipSupport.label,
            price: calculateFeaturePrice(features.vipSupport, true)
        });
    }
    if (values.freePlagiarismReport) {
        resultFeatures.push({
            key: 'freePlagiarismReport',
            label: features.freePlagiarismReport.label,
            price: 0
        });
    }
    if (values.freeAbstractPage) {
        resultFeatures.push({
            key: 'freeAbstractPage',
            label: features.freeAbstractPage.label,
            price: 0
        });
    }
    if (values.freeEditorCheck) {
        resultFeatures.push({
            key: 'freeEditorCheck',
            label: features.freeEditorCheck.label,
            price: 0
        });
    }

    if (values.freeVipSupport) {
        resultFeatures.push({
            key: 'freeVipSupport',
            label: features.freeVipSupport.label,
            price: 0,
        });
    }

    const usedSourcesLi = <li key="usedSources">
        <div className="sidebar-list-left">Used sources</div>
        <div className="sidebar-list-right">Free</div>
    </li>;

    if (!resultFeatures.length) {
        return usedSourcesLi;
    }

    return [
        ...resultFeatures
            .filter(feature => feature.type !== FEATURE_PRICE_TYPE_PRICE_PER_SOURCE)
            .map(feature => (
                <li key={feature.key}>
                    <div className="sidebar-list-left">{feature.label}</div>
                    {feature.price === 0 ? (
                        <div className="sidebar-list-right">Free</div>
                    ) : (
                        <div className="sidebar-list-right">
                            {priceFormat(feature.price)}
                        </div>
                    )}
                </li>
            )),
        usedSourcesLi
    ];
}

export default Features;
